import React, {Component} from 'react';
import {Input, Typography} from "antd";
import {connect} from "react-redux";
import {IAppState} from "../../../redux/store";
import selectors from "../../../redux/selectors";
import {SizeType} from "antd/es/config-provider/SizeContext";
import LocaleText from "../../app/settings/dictionary/LocaleText";

interface IProps {
    value?: string
    onChange?: (value?: string) => void
    className?: string,
    size?: SizeType
    placeholder?: string
    style?: React.CSSProperties,
    disabled?: boolean
    getText: (code: string, language: string, fallBack?: string) => string
}

interface IState {
    language: string
    value?: string
}

class CronSyntax extends Component<IProps, IState> {

    onChange = (value?: string) => {
        this.props.onChange?.(value)
    }

    render() {

        const {className, style, disabled, size, placeholder, value} = this.props

        return (
            <div className={"translation-input " + (className || '')} style={style}>
                <Input value={value} disabled={disabled} size={size} placeholder={placeholder} onChange={e => this.onChange(e.target.value)}/>
                <div>
                    <Typography.Text disabled={true}>
                        <LocaleText code={'configuration.cron-syntax.help'} fallback={'Vysvětlení syntaxe naleznete na '}/>
                        <a href={'https://crontab.guru/#' + value?.replaceAll(' ', '_') } target={"_blank"} rel="noreferrer">https://crontab.guru/</a>
                    </Typography.Text>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState) => {
    return {
        getText: (code: string, language: string, fallback?: string) => selectors.dictionary.getMessage(state, code, fallback, {}, language),
    }
}

export default connect(mapStateToProps)(CronSyntax)
